import React from 'react';
import { SmartMenu } from '../navigation/SmartMenu';

export const Sidebar: React.FC = () => {
  return <SmartMenu />;
};
